import { render, staticRenderFns } from "./tag-list.vue?vue&type=template&id=51accef4&scoped=true"
import script from "./tag-list.ts?vue&type=script&lang=ts&external"
export * from "./tag-list.ts?vue&type=script&lang=ts&external"
import style0 from "./tag-list.less?vue&type=style&index=0&id=51accef4&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51accef4",
  null
  
)

export default component.exports